import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'John Kamau',
    role: 'Local Distributor',
    quote: 'GreenSlopes Farm consistently produces the highest quality milk in the region. Their reliability and professionalism make them a perfect partner.'
  }, {
    name: 'Sarah Wanjiku',
    role: 'Agricultural Officer',
    quote: 'A model farm for Nyandarua. Their sustainable practices and herd management set a benchmark for others to follow.'
  }, {
    name: 'David Njoroge',
    role: 'Visitor',
    quote: 'Visiting the farm was an eye-opener. The passion for farming and the history of the place is truly inspiring. Highly recommended!'
  }];
  return <section className="py-20 bg-green-50" data-id="element-346">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
        <div className="text-center mb-16" data-id="element-348">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-349">
            What People Say
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-350">
            Don't just take our word for it. Here's what our partners and
            visitors have to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-351">
          {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-green-100 relative" data-id="element-352">
              <div className="flex text-amber-400 mb-4" data-id="element-353">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-354" />)}
              </div>
              <p className="text-gray-600 italic mb-6" data-id="element-355">"{item.quote}"</p>
              <div data-id="element-356">
                <p className="font-bold text-gray-900" data-id="element-357">{item.name}</p>
                <p className="text-green-600 text-sm" data-id="element-358">{item.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}